import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { BaseResponse } from '../models'
import { PermissionId } from '../../models/Permission'
import { PermissionType } from '../../contexts/permission/PermissionModel'

const _BASE_URL = import.meta.env.REACT_APP_IAM_API_BASE_URL

interface PermissionResponseDTO {
  id: PermissionId
  type: PermissionType
  description: string
}

export const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    listPermissions: builder.query<BaseResponse<PermissionResponseDTO[]>, void>({
      query: () => ({
        url: '/permissions/',
        method: 'GET',
      }),
    }),
    listOAuth2Scopes: builder.query<BaseResponse<PermissionResponseDTO[]>, void>({
      query: () => ({
        url: '/permissions/',
        method: 'GET',
        params: { scope: 'oauth2' },
      }),
    }),
  }),
})

export const { useListPermissionsQuery, useListOAuth2ScopesQuery } = permissionsApi
